import IconSynchronize from './IconSynchronize';

export const Icon = {
  component: IconSynchronize,
  props: {},
  group: 'icons',
};
